export default "<amobee-loader loading=\"true\"></amobee-loader>"